import { usePathname } from 'next/navigation';

import { navigateToOldProject, pathToBreadcrumbs } from '@/utils/url';

export const useToOldStuCenter = () => {
  const pathname = usePathname();

  const toOldStuCenter = (path: string, target: string = '_self') => {
    const { combineKey } = pathToBreadcrumbs(pathname);
    const separator = path.includes('?') ? '&' : '?';
    navigateToOldProject(
      `${path}${separator}isNewNav=1&breadPath=${combineKey}`,
      target,
    );
  };

  return {
    toOldStuCenter,
  };
};
